import { genericFetch } from "./common-service"
import { apiBaseUrl } from "./config"
import {
	createServiceGroupRequestBody
} from "./factory"
import { ServiceGroupRequestBody } from "./request-body"
import { getBaseHeader } from "./utils"
import ApiError, { ApiErrorCode } from "../../error/api-error"
import * as Model from "../../model"

const serviceNotFoundError = new ApiError(ApiErrorCode.NotFound, "Le service n'existe pas.")
const unexpectedError      = new Error("Unexpected error.")

const SERVICE_GROUPS       = "servicegroups"
const LOCAL_AUTHORITIES    = "localauthorities"
const POLITIQUE            = "political-approach"
const LOCAL_AUTHORITY = "localautority"

export function createServiceGroup(
	localAuthority: Model.LocalAuthority,
	label: string
): Promise<Model.ServiceGroup> {
	const url = `${apiBaseUrl}/${LOCAL_AUTHORITIES}/${localAuthority.id}/${SERVICE_GROUPS}`
	const serviceGroupRB: ServiceGroupRequestBody = createServiceGroupRequestBody(localAuthority.id, label)
	const init: RequestInit = {
		body: JSON.stringify(serviceGroupRB),
		headers: {
			...getBaseHeader(),
			"Content-Type": "application/json"
		},
		method: "POST"
	}

	return fetch(url, init)
	.then(response => {
		switch (response.status) {
			case 200:
				return response.json().then(value => value as Model.ServiceGroup)
			case 401:
				throw new ApiError(ApiErrorCode.Unauthorized, "Vous n'êtes pas autorisé à créer de groupe de service pour cette collectivité.")
			case 404:
				throw serviceNotFoundError
		}
		throw unexpectedError
	})
}

export function deleteServiceGroup(
	serviceGroup: Model.ServiceGroup
): Promise<void> {
	const url = `${apiBaseUrl}/${LOCAL_AUTHORITIES}/${serviceGroup.localAuthority}/${SERVICE_GROUPS}/${serviceGroup.id}`
	const init: RequestInit = {
		headers: getBaseHeader(),
		method: "DELETE"
	}
	return genericFetch<void>(url, init)
}

export function findServiceGroups(localAuthority: Model.LocalAuthority): Promise<Model.ServiceGroup[]> {
	const url = `${apiBaseUrl}/${LOCAL_AUTHORITIES}/${localAuthority.id}/${SERVICE_GROUPS}`
	const init: RequestInit = { headers: getBaseHeader() }

	return genericFetch<Model.ServiceGroup[]>(url, init)
}


export function findPolitique(localAuthority: Model.LocalAuthority): Promise<Model.ServiceGroup[]> {
	const url = `${apiBaseUrl}/${LOCAL_AUTHORITY}/${localAuthority.id}/${POLITIQUE}`
	const init: RequestInit = { headers: getBaseHeader() }

	return genericFetch<Model.ServiceGroup[]>(url, init)
}

export function findOneServiceGroup(localAuthority: Model.LocalAuthority, id: number): Promise<Model.ServiceGroup> {
	const url : string      = `${apiBaseUrl}/${LOCAL_AUTHORITIES}/${localAuthority.id}/${SERVICE_GROUPS}/${id}`
	const init: RequestInit = { headers: getBaseHeader() }

	return fetch(url, init)
	.then(response => {
		switch (response.status) {
			case 200:
				return response.json().then(value => value as Model.ServiceGroup)
			case 401:
				throw new ApiError(ApiErrorCode.Unauthorized, "Vous n'êtes pas autorisé à voir ce gestionnaire de cette collectivité.")
			case 404:
				throw serviceNotFoundError
		}
		throw unexpectedError
	})
}

export function updateServiceGroup(localAuthority: Model.LocalAuthority, serviceGroup: Model.ServiceGroup): Promise<Model.ServiceGroup> {
	const url = `${apiBaseUrl}/${LOCAL_AUTHORITIES}/${localAuthority.id}/${SERVICE_GROUPS}/${serviceGroup.id}`
	const body = JSON.stringify(createServiceGroupRequestBody(localAuthority.id, serviceGroup.label))
	const init: RequestInit = {
		body,
		headers: {
			...getBaseHeader(),
			"Content-Type": "application/json"
		},
		method: "PUT"
	}
	return genericFetch<Model.ServiceGroup>(url, init)
}


// WEBPACK FOOTER //
// ./src/service/sfp/service-group-service.ts